const ladas = [
	{ key: 'mx', value: '+52', flag: 'mx', text: 'México (+52)' },
	{ key: 'us', value: '+1', flag: 'us', text: 'Estados Unidos (+1)' },
]

export default ladas
